import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_sunday_offer_paywall~1
		female: {
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_sunday_offer_paywall/female'),
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_sunday_offer_paywall~1
		male: {
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_sunday_offer_paywall/male'),
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_sunday_offer_paywall~1
		'activity-female-tai-chi-walking-v2': {
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_sunday_offer_paywall/activity-female-tai-chi-walking-v2'),
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_sunday_offer_paywall~1
		'activity-male-walking': {
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_sunday_offer_paywall/activity-male-walking'),
			},
		},
	},
]

export default config
